export const toggleSettingsPanel = (state) => {
  state.isOpen = !state.isOpen;
}
